/* ==========================================================================
   NOMOSAN Bewegung

   Ein Beobachter fuer die ganze Seite. Jedes Element mit .n-auf steigt
   genau einmal auf und wird danach nicht mehr beobachtet - wiederholtes
   Ein- und Ausblenden beim Hoch- und Runterscrollen ermuedet.

   Wer Bewegung abgeschaltet hat, bekommt sofort den Endzustand. Das ist
   bei dieser Zielgruppe keine Randnotiz: Schwindel und Migraene sind in
   dieser Altersgruppe verbreitet.
   ========================================================================== */

(function () {
  'use strict';

  var reduziert = window.matchMedia('(prefers-reduced-motion: reduce)');

  function alleSofortZeigen() {
    document.querySelectorAll('.n-auf').forEach(function (el) {
      el.classList.add('n-da');
    });
  }

  function start() {
    if (reduziert.matches || !('IntersectionObserver' in window)) {
      alleSofortZeigen();
      return;
    }

    var beobachter = new IntersectionObserver(function (eintraege, selbst) {
      eintraege.forEach(function (eintrag) {
        if (!eintrag.isIntersecting) return;
        eintrag.target.classList.add('n-da');
        selbst.unobserve(eintrag.target);
      });
    }, {
      // Etwas frueher als die Sichtgrenze, damit nichts "aufpoppt",
      // wenn jemand langsam scrollt.
      rootMargin: '0px 0px -12% 0px',
      threshold: 0.08
    });

    document.querySelectorAll('.n-auf').forEach(function (el) {
      beobachter.observe(el);
    });

    // Im Theme-Editor werden Sektionen nachgeladen. Ohne das hier blieben
    // frisch eingefuegte Sektionen unsichtbar, und der Chef denkt, es sei
    // kaputt.
    document.addEventListener('shopify:section:load', function (e) {
      e.target.querySelectorAll('.n-auf').forEach(function (el) {
        beobachter.observe(el);
      });
    });
  }

  // Falls jemand die Einstellung waehrend des Besuchs aendert.
  if (reduziert.addEventListener) {
    reduziert.addEventListener('change', function () {
      if (reduziert.matches) alleSofortZeigen();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();


/* ==========================================================================
   Kopfleiste: eine Zeile, Rest unter "Mehr"

   Das Menue hat 13 Punkte und lief ueber vier Zeilen - die Kopfleiste sah
   aus wie eine Linkliste. Statt Punkte zu loeschen (das entscheidet der
   Chef), messen wir hier, was in eine Zeile passt, und schieben den Rest in
   ein Klappmenue "Mehr". Kein Link geht verloren.
   ========================================================================== */
(function () {
  // Dawn legt je nach Einstellung mehrere Navigationsleisten ins Dokument
  // (Klappmenue und Mega-Menue). Sichtbar ist immer nur eine - welche,
  // entscheidet das Theme. Also nehmen wir uns jede vor.
  var zaehler = 0;
  var leisten = document.querySelectorAll('.header__inline-menu > .list-menu--inline');
  Array.prototype.forEach.call(leisten, einrichten);

function einrichten(leiste) {
  var punkte = Array.prototype.slice.call(leiste.children);
  if (punkte.length < 4) return;

  // Klappmenue "Mehr" im Dawn-Markup, damit Tastatur und Maus so
  // funktionieren wie bei den anderen Punkten.
  var pfeil = leiste.querySelector('summary svg');
  var mehr = document.createElement('li');
  mehr.className = 'n-mehr';
  mehr.innerHTML =
    '<header-menu><details id="Details-HeaderMenu-Mehr-' + (zaehler += 1) + '">' +
    '<summary class="header__menu-item list-menu__item link focus-inset"><span>Mehr</span></summary>' +
    '<ul class="header__submenu list-menu list-menu--disclosure gradient caption-large motion-reduce global-settings-popup" role="list" tabindex="-1"></ul>' +
    '</details></header-menu>';
  if (pfeil) mehr.querySelector('summary').appendChild(pfeil.cloneNode(true));
  var mehrListe = mehr.querySelector('ul');
  leiste.appendChild(mehr);

  // Passt alles in eine Zeile? Immer frisch messen: die Leiste sitzt
  // senkrecht mittig, sie rutscht also selbst nach oben, sobald sie
  // schrumpft. Ein einmal gemerkter Zeilenwert waere nach dem ersten
  // Verschieben falsch - und dann raeumt die Schleife alles weg.
  function einzeilig() {
    var kinder = leiste.children;
    if (kinder.length < 2) return true;
    var oben = kinder[0].offsetTop;
    for (var k = 1; k < kinder.length; k++) {
      if (kinder[k].offsetTop > oben + 2) return false;
    }
    return true;
  }

  function ordnen() {
    // Erst alles zurueck in die Reihe, dann neu messen.
    punkte.forEach(function (li) { leiste.insertBefore(li, mehr); });
    mehr.style.display = 'none';

    if (window.innerWidth < 990) return;

    // Dawn laedt einen Teil seiner Gestaltung nach. Wer davor misst, misst
    // eine Liste ohne Flex - dann steht jeder Punkt in einer eigenen Zeile
    // und wir raeumen die ganze Navigation weg. Also erst messen, wenn die
    // Reihe wirklich eine Reihe ist.
    if (getComputedStyle(leiste).display.indexOf('flex') === -1) return;

    if (einzeilig()) return;

    mehr.style.display = '';
    var i = punkte.length - 1;
    while (i >= 0 && !einzeilig()) {
      mehrListe.insertBefore(punkte[i], mehrListe.firstChild);
      i--;
    }
  }

  var takt;
  window.addEventListener('resize', function () {
    clearTimeout(takt);
    takt = setTimeout(ordnen, 150);
  });
  document.addEventListener('shopify:section:load', function () { setTimeout(ordnen, 0); });
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(ordnen);
  window.addEventListener('load', ordnen);
  ordnen();
}
})();


/* ==========================================================================
   Kaufleiste am unteren Rand (mobil)

   Auf dem Telefon ist der Kaufknopf nach zwei Wischern weg. Wer sich dann
   entscheidet, muesste zurueckscrollen - die meisten tun das nicht. Also
   holen wir den Knopf zurueck, sobald der echte aus dem Bild ist. Geklickt
   wird immer der echte Knopf, damit Varianten und Warenkorb genau so
   funktionieren wie sonst.
   ========================================================================== */
(function () {
  var echt = document.querySelector('.product-form__submit');
  if (!echt) return;

  var name = document.querySelector('.product__title h1, .product__title h2, .product__title');
  var preis = document.querySelector('.product .price__container .price-item--sale, .product .price__container .price-item--regular');

  var leiste = document.createElement('div');
  leiste.className = 'n-kaufleiste';
  leiste.innerHTML =
    '<div class="n-kaufleiste__wort">' +
    '<span class="n-kaufleiste__name"></span>' +
    '<span class="n-kaufleiste__preis"></span>' +
    '<span class="n-kaufleiste__einheiten"></span>' +
    '</div>' +
    '<button type="button" class="n-kaufleiste__knopf"></button>';
  var knopf = leiste.querySelector('.n-kaufleiste__knopf');
  leiste.querySelector('.n-kaufleiste__name').textContent = name ? name.textContent.trim() : '';
  document.body.appendChild(leiste);

  // Beschriftung, Preis und Verfuegbarkeit vom echten Knopf uebernehmen -
  // auch nachdem Dawn beim Variantenwechsel neu gerendert hat.
  function abgleichen() {
    var text = echt.querySelector('span');
    knopf.textContent = text ? text.textContent.trim() : 'In den Warenkorb';
    knopf.disabled = echt.disabled;
    var priceBlock = document.querySelector('.product .price');
    var p = priceBlock && priceBlock.querySelector(priceBlock.classList.contains('price--on-sale') ? '.price__sale .price-item--sale' : '.price__regular .price-item--regular');
    leiste.querySelector('.n-kaufleiste__preis').textContent = p ? p.textContent.trim() : '';
    var units = priceBlock && priceBlock.querySelector('.nomosan-unit-prices');
    var unitTarget = leiste.querySelector('.n-kaufleiste__einheiten');
    unitTarget.replaceChildren();
    if (units) unitTarget.appendChild(units.cloneNode(true));
    sichtbarkeit();
  }
  abgleichen();
  var productInfo = document.querySelector('.product__info-container') || echt;
  new MutationObserver(abgleichen).observe(productInfo, { attributes: true, childList: true, subtree: true });

  knopf.addEventListener('click', function () { echt.click(); });

  // Keep the bar in sync even when a scroll jumps past the buy button.
  function sichtbarkeit() {
    var active = echt.getBoundingClientRect().bottom < 0;
    leiste.classList.toggle('n-kaufleiste--an', active);
  }
  window.addEventListener('scroll', sichtbarkeit, { passive: true });
  window.addEventListener('resize', sichtbarkeit);
  if ('IntersectionObserver' in window) {
    new IntersectionObserver(sichtbarkeit, { threshold: 0 }).observe(echt);
  }
  sichtbarkeit();
})();
